export const REFERENCE_INPUT_ELEMENT = "reference-input-element";
